import { intl } from "../i18n/TypedIntl";
import { emailIsGood } from "./emailIsGood";
import { validatePasswordPolicy } from "./validatePasswordPolicy";

export function validateUrl(val: string) {
  return val.match(
    /^(?:http(s)?:\/\/)?[\w.-]+(?:\.[\w\.-]+)+[\w\-\._~:/?#[\]@!\$&'\(\)\*\+,;=.]+$/gm
  )
    ? ""
    : intl.formatMessage("error.urlInvalid");
}

export function validatePassword(val: string) {
  return !val || Object.values(validatePasswordPolicy(val)).includes(false)
    ? intl.formatMessage("error.passwordInvalid")
    : "";
}

export function validateEmail(val: string) {
  return val && !emailIsGood(val) ? intl.formatMessage("error.emailInvalid") : "";
}

export function validateRequired(val?: string) {
  return val ? "" : intl.formatMessage("error.fieldRequired");
}

export function validateNoWhitespace(val?: string) {
  return val && val.indexOf(" ") === -1 ? "" : intl.formatMessage("error.hasWhitespaces");
}

export function validateIntentName(val?: string) {
  return val && /^[a-zA-Z0-9_]+$/g.test(val)
    ? ""
    : intl.formatMessage("ai.modelConfiguration.intent.form.name.description");
}

export function validateRequiredNumber(val?: number) {
  return val !== undefined && !isNaN(val) ? "" : intl.formatMessage("error.fieldRequired");
}

export function validateSeconds(val?: number) {
  return val !== undefined && val < 60 ? "" : intl.formatMessage("error.seconds");
}

export function validateArrayNonEmpty<T extends unknown>(val?: T[]) {
  return val && val.length > 0 ? "" : intl.formatMessage("error.fieldRequired");
}

export function validateNumberInRange(min: number, max: number) {
  return (value: number) =>
    Math.max(Math.min(value, max), min) === value
      ? ""
      : intl.formatMessage("error.numberOutOfRange", { min, max });
}

export function validateStringMaxLength(maxLength: number) {
  return (value: string) =>
    value.length <= maxLength ? "" : intl.formatMessage("error.stringMaxLength", { maxLength });
}

export function validateNumberWithSeparators(separators: RegExp) {
  return (value: string) =>
    value.split(separators).every((chunk) => /^[0-9]+$/.test(chunk))
      ? ""
      : intl.formatMessage("error.numberWithSeparators");
}
